// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/range.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/weight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Images/time.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../Images/altitude.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../Images/speed.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../Images/payload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../Images/lunch.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../Images/landing.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.Twentynine_aw-container__3XZ\\+J {
  width: 100%;
  height: 100vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("https://i.imgur.com/GYJHv1u.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

/* Գլխավոր դիվը էկրանով ամբողջությամբ */
.Twentynine_aw-section-one__7-g5A {
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: 40px 60px;
}

/* Ձախ ներքևի տեքստ */
.Twentynine_aw-container__3XZ\\+J h3 {
  font-size: 80px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  color: rgba(255, 255, 255, 0.5019607843);
  opacity: 0.5;
  margin-top: 550px;
}

/* Աջ կողմի նկարը */
.Twentynine_aw-image__y8HkU {
  width: 1800px;
  height: 750px;
  background-image: url("https://i.imgur.com/emNolMb.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.Twentynine_sections__GLo9E {
  width: 100%;
  max-width: 1500px;
  margin: auto;
  margin-top: -180px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.Twentynine_product-section__J7fqL {
  width: 80%;
  height: 113px;
  display: flex;
  margin: auto;
  background-color: #252626;
  margin-bottom: 100px;
  justify-content: space-around;
  align-items: center;
}

.Twentynine_product-section__J7fqL span {
  color: white;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  font-family: "Roboto", sans-serif;
}

.Twentynine_product-section__J7fqL button {
  width: 300px;
  height: 66px;
  border-radius: 32px;
  border: solid white;
  background-color: #252626;
  color: white;
  font-size: 32px;
  font-weight: 700;
  cursor: pointer;
}

.Twentynine_sections-child__I05dR {
  width: 324px;
  height: 225px;
  background-color: white;
  box-shadow: 1px 1px 1px;
  border-bottom: 1px solid;
  border-right: 1px solid;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 40px;
  transform: perspective(1px) translateZ(0);
  box-shadow: 2px 2px 2px transparent;
  transition-duration: 0.3s;
  transition-property: box-shadow, transform;
}

.Twentynine_child-img__OpQOk {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Twentynine_sections-child__I05dR h2 {
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  color: #4C6D59;
  text-align: center;
}

.Twentynine_sections-child__I05dR p {
  color: #4C6D59;
  font-weight: 500;
  font-size: 25.5px;
  line-height: 100%;
}

.Twentynine_weight-img__NzArG {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Twentynine_time-img__oThD9 {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Twentynine_altitude-img__nZW-O {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Twentynine_speed-img__W4741 {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Twentynine_payload-img__EoWS2 {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Twentynine_lunch-img__pXHDi {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Twentynine_landing-img__DcO39 {
  width: 82px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 20px;
}

.Twentynine_p-Container__6ZT9X {
  width: 80%;
}

.Twentynine_p-Container__6ZT9X p {
  color: white;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  font-family: "Roboto", sans-serif;
}

.Twentynine_paragraph-section__824h4 {
  width: 80%;
  background-color: #4C6D59;
  margin: auto;
  display: flex;
  justify-content: center;
  margin-top: 100px;
  margin-bottom: 150px;
}

.Twentynine_paragraph-big__bIhOu {
  width: 100%;
  margin: auto;
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: stretch;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 48px;
  position: relative;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
}

.Twentynine_paragraph-big__bIhOu p {
  color: white;
  font-size: 32px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  width: 65%;
  line-height: 1.4;
}

.Twentynine_paragraph-small-container__E\\+iN\\+ {
  display: flex;
  height: 60%;
  margin-top: 200px;
  flex-direction: column;
  justify-content: space-between;
  margin-left: -70px;
  z-index: 99;
}

.Twentynine_paragraph-small__KLyy5 {
  width: 149px;
  height: 94px;
  border: 2px solid white;
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: white;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
}

@media (max-width: 1000px) {
  .Twentynine_product-section__J7fqL {
    margin-top: -340px;
  }
  .Twentynine_product-section__J7fqL span {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .Twentynine_product-section__J7fqL button {
    font-size: 16px;
    height: 32px;
    width: 100px;
  }
}
@media screen and (max-width: 1024px) {
  .Twentynine_paragraph-big__bIhOu {
    flex-direction: column;
    padding: 30px;
  }
  .Twentynine_paragraph-section__824h4 {
    max-width: 500px;
    width: 80%;
  }
  .Twentynine_paragraph-big__bIhOu {
    margin-left: -2px;
  }
  .Twentynine_sections-child__I05dR {
    width: 280px;
    height: 250px;
  }
  .Twentynine_paragraph-big__bIhOu p {
    width: 100%;
    font-size: 24px;
    margin-bottom: 30px;
    text-align: center;
  }
  .Twentynine_paragraph-section__824h4 {
    height: 500px;
  }
  .Twentynine_p-Container__6ZT9X p {
    color: white;
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
    font-family: "Roboto", sans-serif;
  }
  .Twentynine_p-Container__6ZT9X h2 {
    font-size: 20px;
  }
  .Twentynine_p-Container__6ZT9X p {
    font-size: 14px;
  }
  .Twentynine_aw-section-one__7-g5A h3 {
    margin-top: 360px;
  }
  .Twentynine_aw-container__3XZ\\+J {
    height: 800px;
  }
  .Twentynine_sections-child__I05dR {
    margin: auto;
    margin-bottom: 25px;
  }
  .Twentynine_product-section__J7fqL {
    margin-top: -500px;
    height: 100px;
  }
  .Twentynine_product-section__J7fqL span {
    margin-top: 22px;
  }
  .Twentynine_aw-image__y8HkU {
    width: 400px;
    height: 185px;
    background-size: cover;
    margin-left: -110px;
    margin-top: -40px;
  }
  .Twentynine_paragraph-small__KLyy5 {
    width: 130px;
    height: 70px;
    font-size: 14px;
    margin-left: 30px;
  }
}
@media screen and (max-width: 600px) {
  .Twentynine_sections-child__I05dR {
    width: 150px;
    height: 150px;
  }
  .Twentynine_sections-child__I05dR h2 {
    font-size: 17px;
    margin-top: 2.5px;
  }
  .Twentynine_sections-child__I05dR p {
    font-size: 14px;
  }
  .Twentynine_paragraph-section__824h4 {
    margin-top: 200px;
  }
  .Twentynine_aw-section-one__7-g5A h3 {
    margin-top: 180px;
    font-size: 19px;
  }
  .Twentynine_aw-container__3XZ\\+J {
    height: 60vh;
  }
  .Twentynine_paragraph-big__bIhOu p {
    font-size: 16px;
  }
  .Twentynine_paragraph-small__KLyy5 {
    width: 110px;
    height: 60px;
    font-size: 12px;
    margin-left: 30px;
  }
  .Twentynine_paragraph-small-container__E\\+iN\\+ {
    flex-direction: column;
    gap: 16px;
    height: 300px;
  }
  .Twentynine_sections-child__I05dR {
    width: 145px;
    height: 140px;
  }
  .Twentynine_child-img__OpQOk {
    width: 50px;
    height: 50px;
  }
  .Twentynine_weight-img__NzArG {
    width: 50px;
    height: 50px;
  }
  .Twentynine_time-img__oThD9 {
    width: 50px;
    height: 50px;
  }
  .Twentynine_altitude-img__nZW-O {
    width: 50px;
    height: 50px;
  }
  .Twentynine_speed-img__W4741 {
    width: 50px;
    height: 50px;
  }
  .Twentynine_payload-img__EoWS2 {
    width: 50px;
    height: 50px;
  }
  .Twentynine_lunch-img__pXHDi {
    width: 50px;
    height: 50px;
  }
  .Twentynine_landing-img__DcO39 {
    width: 50px;
    height: 50px;
  }
}
@media screen and (max-width: 530px) {
  .Twentynine_paragraph-big__bIhOu p {
    font-size: 12px;
  }
  .Twentynine_paragraph-small-container__E\\+iN\\+ {
    margin-top: 160px;
  }
  .Twentynine_paragraph-big__bIhOu {
    height: 500px;
  }
}
@media screen and (min-width: 1025px) {
  .Twentynine_aw-section-one__7-g5A h3 {
    font-size: 68px;
    margin-top: 600px;
  }
}
.Twentynine_sections-child__I05dR:hover,
.Twentynine_sections-child__I05dR:focus,
.Twentynine_sections-child__I05dR:active {
  cursor: pointer;
  box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);
  transform: scale(1.2);
}`, "",{"version":3,"sources":["webpack://./src/AW29/Twentynine.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EAEA,kHAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;AACF;;AAEA,uCAAA;AACA;EACE,aAAA;EACA,8BAAA;EAEA,YAAA;EACA,WAAA;EACA,kBAAA;AAAF;;AAGA,qBAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,wCAAA;EACA,YAAA;EACA,iBAAA;AAAF;;AAGA,mBAAA;AACA;EACE,aAAA;EACA,aAAA;EACA,wDAAA;EACA,wBAAA;EACA,4BAAA;AAAF;;AAIA;EACE,WAAA;EACA,iBAAA;EAGA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AAHF;;AAOA;EACE,UAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;AAJF;;AASA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AANF;;AASA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AANF;;AAUA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EAEA,wBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,yBAAA;EACA,0CAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AARF;;AAWA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AARF;;AAWA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AARF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;AATF;;AAWA;EACE,UAAA;AARF;;AAiBA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAdF;;AAkBA;EACE,UAAA;EAEA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,0CAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AAhBF;;AAqBA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;EACA,gBAAA;AAlBF;;AAsBA;EAEE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,8BAAA;EAIA,kBAAA;EACA,WAAA;AAvBF;;AA4BA;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iCAAA;EACA,6BAAA;AAzBF;;AA6BA;EAGE;IACE,kBAAA;EA5BF;EA+BA;IACE,eAAA;IACA,mBAAA;EA7BF;EAiCA;IACE,eAAA;IACA,YAAA;IACA,YAAA;EA/BF;AACF;AAmCA;EACE;IACE,sBAAA;IACA,aAAA;EAjCF;EAqCA;IACE,gBAAA;IACA,UAAA;EAnCF;EAwCA;IAEE,iBAAA;EAvCF;EA0CA;IACE,YAAA;IACA,aAAA;EAxCF;EA2CA;IACE,WAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EAzCF;EA4CA;IACE,aAAA;EA1CF;EA4CA;IACE,YAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,iCAAA;EA1CF;EA4CA;IACE,eAAA;EA1CF;EA+CA;IACE,eAAA;EA7CF;EAiDA;IAEE,iBAAA;EAhDF;EAqDA;IACE,aAAA;EAnDF;EA6DA;IACE,YAAA;IACA,mBAAA;EA3DF;EA+DA;IACE,kBAAA;IACA,aAAA;EA7DF;EAgEA;IACE,gBAAA;EA9DF;EAiEA;IAEE,YAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,iBAAA;EAhEF;EAmEA;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAjEF;AACF;AAoEA;EAEE;IACE,YAAA;IACA,aAAA;EAnEF;EAsEA;IACE,eAAA;IACA,iBAAA;EApEF;EAuEA;IACE,eAAA;EArEF;EAwEA;IACE,iBAAA;EAtEF;EA6EA;IAEE,iBAAA;IACA,eAAA;EA5EF;EA8EA;IACE,YAAA;EA5EF;EA+EA;IACE,eAAA;EA7EF;EAgFA;IACE,YAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EA9EF;EAmFA;IACE,sBAAA;IACA,SAAA;IACA,aAAA;EAjFF;EAqFA;IACE,YAAA;IACA,aAAA;EAnFF;EAqFA;IACE,WAAA;IACA,YAAA;EAnFF;EAsFA;IACE,WAAA;IACA,YAAA;EApFF;EAuFA;IACE,WAAA;IACA,YAAA;EArFF;EAwFA;IACE,WAAA;IACA,YAAA;EAtFF;EAyFA;IACE,WAAA;IACA,YAAA;EAvFF;EA0FA;IACE,WAAA;IACA,YAAA;EAxFF;EA0FA;IACE,WAAA;IACA,YAAA;EAxFF;EA0FA;IACE,WAAA;IACA,YAAA;EAxFF;AACF;AA6FA;EACE;IACE,eAAA;EA3FF;EA8FA;IACE,iBAAA;EA5FF;EA+FA;IACE,aAAA;EA7FF;AACF;AAkGA;EACE;IAEE,eAAA;IACA,iBAAA;EAjGF;AACF;AA0GA;;;EAGE,eAAA;EACA,mDAAA;EACA,qBAAA;AAxGF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.aw-container {\n  width: 100%;\n  height: 100vh;\n  //background-color: #252626;\n  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(\"https://i.imgur.com/GYJHv1u.jpeg\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n}\n\n/* Գլխավոր դիվը էկրանով ամբողջությամբ */\n.aw-section-one {\n  display: flex;\n  justify-content: space-between;\n  //align-items: flex-end;\n  height: 100%;\n  width: 100%;\n  padding: 40px 60px;\n}\n\n/* Ձախ ներքևի տեքստ */\n.aw-container h3 {\n  font-size: 80px;\n  font-weight: 700;\n  font-family: 'Roboto', sans-serif;\n  color: #FFFFFF80;\n  opacity: 0.5;\n  margin-top: 550px;\n}\n\n/* Աջ կողմի նկարը */\n.aw-image {\n  width: 1800px;\n  height: 750px;\n  background-image: url(\"https://i.imgur.com/emNolMb.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  //background-position: center;\n}\n\n.sections {\n  width: 100%;\n  max-width: 1500px;\n  //height: 70vh;\n  //background-color: red;\n  margin: auto;\n  margin-top: -180px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n\n.product-section {\n  width: 80%;\n  height: 113px;\n  display: flex;\n  margin: auto;\n  background-color: #252626;\n  margin-bottom: 100px;\n  justify-content: space-around;\n  align-items: center;\n\n\n}\n\n.product-section span {\n  color: white;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.product-section button {\n  width: 300px;\n  height: 66px;\n  border-radius: 32px;\n  border: solid white;\n  background-color: #252626;\n  color: white;\n  font-size: 32px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n\n.sections-child {\n  width: 324px;\n  height: 225px;\n  background-color: white;\n  box-shadow: 1px 1px 1px;\n  //display: flex;\n  border-bottom: 1px solid;\n  border-right: 1px solid;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 40px;\n  transform: perspective(1px) translateZ(0);\n  box-shadow: 2px 2px 2px transparent;\n  transition-duration: 0.3s;\n  transition-property: box-shadow, transform;\n}\n\n.child-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/range.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.sections-child h2 {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 100%;\n  color: #4C6D59;\n  text-align: center;\n}\n\n.sections-child p {\n  color: #4C6D59;\n  font-weight: 500;\n  font-size: 25.5px;\n  line-height: 100%;\n}\n\n.weight-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/weight.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.time-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/time.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n\n.altitude-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/altitude.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.speed-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/speed.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.payload-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/payload.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.lunch-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/lunch.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n\n.landing-img {\n  width: 82px;\n  height: 82px;\n  background-image: url(\"../Images/landing.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 20px;\n}\n.p-Container {\n  width: 80%;\n  //display: flex;\n\n  //justify-content: center;\n  //align-items: center;\n  //text-align: center;\n\n}\n\n.p-Container p{\n  color: white;\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n\n.paragraph-section {\n  width: 80%;\n  //height: 70vh;\n  background-color: #4C6D59;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  margin-top: 100px;\n  margin-bottom: 150px;\n}\n\n.paragraph-big {\n  width: 100%;\n  margin: auto;\n  padding: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  background-color: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 48px;\n  position: relative;\n  margin-top: 100px;\n  margin-bottom: 100px;\n  text-align: center;\n\n\n}\n\n.paragraph-big p {\n  color: white;\n  font-size: 32px;\n  font-weight: 500;\n  font-family: 'Roboto', sans-serif;\n  width: 65%;\n  line-height: 1.4;\n\n}\n\n.paragraph-small-container {\n  //width: 30%;\n  display: flex;\n  height: 60%;\n  margin-top: 200px;\n  flex-direction: column;\n  justify-content: space-between;\n  //align-items: flex-end;\n  //background-color: red;\n  //position: absolute;\n  margin-left: -70px;\n  z-index: 99;\n\n\n}\n\n.paragraph-small {\n  width: 149px;\n  height: 94px;\n  border: 2px solid white;\n  border-radius: 19px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  color: white;\n  font-family: 'Roboto', sans-serif;\n  background-color: transparent;\n\n}\n\n@media (max-width: 1000px) {\n\n\n  .product-section{\n    margin-top: -340px;\n  }\n\n  .product-section span {\n    font-size: 16px;\n    margin-bottom: 20px;\n\n  }\n\n  .product-section button {\n    font-size: 16px;\n    height: 32px;\n    width:100px;\n\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .paragraph-big {\n    flex-direction: column;\n    padding: 30px;\n    //height: 50vh;\n\n  }\n  .paragraph-section {\n    max-width: 500px;\n    width: 80%;\n\n    //margin: auto;\n    //background-color: red;\n  }\n  .paragraph-big {\n    //background-color: red;\n    margin-left: -2px;\n  }\n\n  .sections-child {\n    width: 280px;\n    height: 250px;\n  }\n\n  .paragraph-big p {\n    width: 100%;\n    font-size: 24px;\n    margin-bottom: 30px;\n    text-align: center;\n  }\n\n  .paragraph-section{\n    height: 500px;\n  }\n  .p-Container p{\n    color: white;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 100%;\n    font-family: 'Roboto', sans-serif;\n  }\n  .p-Container h2{\n    font-size: 20px;\n  }\n\n\n\n  .p-Container p{\n    font-size: 14px;\n  }\n\n\n  .aw-section-one h3 {\n    //background-color: red;\n    margin-top: 360px;\n    //font-size: 19px;\n\n  }\n\n  .aw-container {\n    height: 800px;\n  }\n\n  //.paragraph-small-container {\n  //  margin: 0 auto;\n  //  flex-direction: row;\n  //  justify-content: center;\n  //  gap: 20px;\n  //  height: auto;\n  //}\n  .sections-child {\n    margin: auto;\n    margin-bottom: 25px;\n  }\n\n\n  .product-section {\n    margin-top: -500px;\n    height: 100px;\n  }\n\n  .product-section span{\n    margin-top: 22px;\n  }\n\n  .aw-image {\n    //margin: auto;\n    width: 400px;\n    height: 185px;\n    background-size: cover;\n    margin-left: -110px;\n    margin-top: -40px;\n\n  }\n  .paragraph-small {\n    width: 130px;\n    height: 70px;\n    font-size: 14px;\n    margin-left: 30px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n  .sections-child{\n    width: 150px;\n    height: 150px;\n  }\n\n  .sections-child h2{\n    font-size: 17px;\n    margin-top: 2.5px;\n  }\n\n  .sections-child p{\n    font-size: 14px;\n  }\n\n  .paragraph-section {\n    margin-top: 200px;\n\n  }\n\n\n\n\n  .aw-section-one h3 {\n    //background-color: red;\n    margin-top: 180px;\n    font-size: 19px;\n  }\n  .aw-container {\n    height: 60vh;\n  }\n\n  .paragraph-big p {\n    font-size: 16px;\n  }\n\n  .paragraph-small {\n    width: 110px;\n    height: 60px;\n    font-size: 12px;\n    margin-left: 30px;\n\n\n  }\n\n  .paragraph-small-container {\n    flex-direction: column;\n    gap: 16px;\n    height: 300px;\n  }\n\n\n  .sections-child{\n    width: 145px;\n    height: 140px;\n  }\n  .child-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .weight-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .time-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .altitude-img{\n    width: 50px;\n    height: 50px;\n\n  }\n  .speed-img{\n    width: 50px;\n    height: 50px;\n  }\n\n  .payload-img{\n    width: 50px;\n    height: 50px;\n  }\n  .lunch-img{\n    width: 50px;\n    height: 50px;\n  }\n  .landing-img{\n    width: 50px;\n    height: 50px;\n  }\n\n}\n\n\n@media screen and (max-width: 530px) {\n  .paragraph-big p {\n    font-size: 12px;\n  }\n\n  .paragraph-small-container {\n    margin-top: 160px;\n    //margin-left: 2px;\n  }\n  .paragraph-big {\n    height: 500px;\n  }\n\n}\n\n\n@media screen and (min-width: 1025px) {\n  .aw-section-one h3 {\n    //background-color: red;\n    font-size: 68px;\n    margin-top: 600px;\n  }\n  //.aw-container{\n  //  height: 50vh;\n  //}\n\n\n}\n\n\n.sections-child:hover,\n.sections-child:focus,\n.sections-child:active {\n  cursor: pointer;\n  box-shadow: 1px 10px 10px -10px rgba(0, 0, 24, 0.5);\n  transform: scale(1.2);\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aw-container": `Twentynine_aw-container__3XZ+J`,
	"aw-section-one": `Twentynine_aw-section-one__7-g5A`,
	"aw-image": `Twentynine_aw-image__y8HkU`,
	"sections": `Twentynine_sections__GLo9E`,
	"product-section": `Twentynine_product-section__J7fqL`,
	"sections-child": `Twentynine_sections-child__I05dR`,
	"child-img": `Twentynine_child-img__OpQOk`,
	"weight-img": `Twentynine_weight-img__NzArG`,
	"time-img": `Twentynine_time-img__oThD9`,
	"altitude-img": `Twentynine_altitude-img__nZW-O`,
	"speed-img": `Twentynine_speed-img__W4741`,
	"payload-img": `Twentynine_payload-img__EoWS2`,
	"lunch-img": `Twentynine_lunch-img__pXHDi`,
	"landing-img": `Twentynine_landing-img__DcO39`,
	"p-Container": `Twentynine_p-Container__6ZT9X`,
	"paragraph-section": `Twentynine_paragraph-section__824h4`,
	"paragraph-big": `Twentynine_paragraph-big__bIhOu`,
	"paragraph-small-container": `Twentynine_paragraph-small-container__E+iN+`,
	"paragraph-small": `Twentynine_paragraph-small__KLyy5`
};
export default ___CSS_LOADER_EXPORT___;
